module.exports = "<div class=\"wrapper\">\n<app-header></app-header>\n<section class=\"content_area\">\n  <div class=\"innercont\">\n    <h1>Dashboard</h1>\n    <p *ngIf=\"dashboard_msg != ''\" class=\"bg-success1\"> \n      {{dashboard_msg}}\n    \n    </p>\n    <h2>\n        Welcome to Dashboard Page.....\n        </h2>\n  </div>\n</section>\n<app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/dashboard.component.html
// module id = ./src/app/dashboard/dashboard.component.html
// module chunks = main